// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1___aa53cc846669d8b9383","cls2":"AccountMenuButton-cls2__f49d7728d12ea9ef2702 AccountMenuButton-cls1___aa53cc846669d8b9383"};